import { isNil } from 'lodash';
import { ReactNode, useCallback } from 'react';
import { Icon } from '@shared/components/Icon';
import { ButtonView, View } from '@shared/components/View';
import { Colors, bounceIn } from '@shared/styles';

interface Props {
  checked: boolean;
  children?: ReactNode;
  onChange?: (newValue: boolean) => void;
}

export function Checkbox({ checked, children, onChange }: Props) {
  const handleChange = useCallback(() => {
    onChange?.(!checked);
  }, [checked, onChange]);

  const checkboxIcon = checked ? 'check-box' : 'check-box-empty';

  return (
    <View row>
      <ButtonView
        row
        key={String(checked)}
        role="checkbox"
        aria-checked={checked}
        disabled={isNil(onChange)}
        onClick={handleChange}
        className={checked && bounceIn}
      >
        <Icon name={checkboxIcon} color={Colors.v2.green} gridSize={4} />
        {children}
      </ButtonView>
    </View>
  );
}
